import React from 'react';
import { services } from '../../Data';
import { FaBolt, FaCode, FaPalette, FaLayerGroup } from 'react-icons/fa';

const ICON_BY_ID = {
  1: FaCode,
  2: FaPalette,
  3: FaBolt,
  4: FaLayerGroup,
};

const Services = () => {
  return (
    <section
      id="services"
      className="relative overflow-hidden bg-gradient-to-b from-[#0b0f17] to-[#070a10] py-20"
    >
      {/* subtle glow */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-tr from-accent/20 via-emerald-500/10 to-transparent blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs tracking-[0.22em] uppercase text-accent/80">What I do</p>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white tracking-tight">
            Services I Offer
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-2xl mx-auto leading-relaxed">
            High-quality frontend engineering focused on performance, accessibility, and clean UX—built
            with React, Next.js, and modern JavaScript.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map(({ id, name, title, description }) => {
            const Icon = ICON_BY_ID[id] || FaCode;
            return (
              <article
                key={id}
                className="group h-full rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-8 shadow-soft transition-transform duration-300 hover:-translate-y-1.5 hover:border-accent/50 hover:shadow-[0_20px_60px_rgba(34,197,94,0.12)]"
              >
                <div className="flex flex-col h-full space-y-4">
                  {/* icon */}
                  <div className="h-10 w-10 rounded-xl border border-white/10 bg-black/30 grid place-items-center text-accent shadow-[0_0_0_1px_rgba(255,255,255,0.04)]">
                    <Icon className="h-5 w-5" />
                  </div>

                  {/* category */}
                  <p className="text-xs tracking-[0.22em] uppercase text-gray-400">{name}</p>

                  {/* title */}
                  <h3 className="text-lg font-semibold text-white tracking-tight">{title}</h3>

                  {/* description */}
                  <p className="text-sm text-gray-400 leading-relaxed flex-1">
                    {description}
                  </p>

                  {/* link */}
                  <a
                    href="#work"
                    className="inline-flex items-center gap-2 text-sm font-semibold text-white/85 transition-colors group-hover:text-white"
                  >
                    <span className="relative">
                      View projects
                      <span className="absolute left-0 -bottom-1 h-[2px] w-full origin-left scale-x-0 bg-accent transition-transform duration-300 group-hover:scale-x-100" />
                    </span>
                    <span className="text-accent transition-transform duration-300 group-hover:translate-x-0.5">
                      →
                    </span>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
